/**
 * appends params to a url
 * @param {Object} item - Original item
 * @returns {string} result renderItem with appended parameters
 */
function renderHTMLForOrderTotalsDiscounts(item) {
    if (item.lineItemText) {
        // eslint-disable-next-line
        const renderItem = `<div class="order-discount leading-lines order-cost-item ${(item.promotionClass === 'SHIPPING') || !item.lineItemText ? 'd-none' : ''}">
                                <span class="order-cost-item-key">${item.lineItemText}</span>
                                <span class="order-cost-item-value">${item.price}</span>
                            </div>`;
        return renderItem;
    }

    return '';
}

const renderingPaymentTemplates = {
    renderHTMLForOrderTotalsDiscounts: renderHTMLForOrderTotalsDiscounts
};

module.exports = renderingPaymentTemplates;
